import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    entId: 'MSPX_ID',
    entName: 'MSPX',
  }
};

export const mspGeneralSlice = createSlice({
  name: "mspGeneral",
  initialState,
  reducers: {
    updateMspGeneral: (state, action) => {
      state.data.entName = action.payload.data.name;
    },
  },
});

export const { updateMspGeneral } = mspGeneralSlice.actions;

export default mspGeneralSlice.reducer;